<template>
  <div class="min-h-screen bg-gray-50 px-4 py-6 pb-24" dir="rtl">
    <div class="max-w-2xl mx-auto space-y-6">
      
      <!-- Header Card -->
      <div class="bg-gradient-to-r from-orange-600 to-orange-700 rounded-xl p-6 text-white">
        <div class="flex items-center gap-3">
          <div class="w-14 h-12 rounded-full bg-white bg-opacity-20 backdrop-blur-sm flex items-center justify-center">
            <svg class="w-6 h-6 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
            </svg>
          </div>
          <div class="w-full">
            <h2 class="text-xl font-bold">گزارش کالاهای ارجاعی</h2>
            <p class="text-sm text-orange-50">انتخاب بازه تاریخ و جستجو</p>
          </div>
        </div>
      </div>

      <!-- Date Pickers and Search -->
      <div class="bg-white rounded-xl border border-gray-200 p-6 space-y-4">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('fromDate') }}</label>
            <date-picker v-model="start_date" class="w-full"></date-picker>
          </div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-2">{{ $t('toDate') }}</label>
            <date-picker v-model="end_date" class="w-full"></date-picker>
          </div>
        </div>
        
        <div>
          <label class="block text-sm font-medium text-gray-700 mb-2">جستجو</label>
          <div class="relative">
            <div class="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
              </svg>
            </div>
            <input
              v-model="search_list"
              type="text"
              placeholder="جستجو در نام محصول..."
              class="w-full pr-4 pl-11 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-orange-500 focus:border-orange-500"
              style="border: 1px solid #d1d5db !important;"
            />
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div v-if="request_items_filtered.length === 0" class="flex flex-col items-center justify-center py-20">
        <div class="w-24 h-24 rounded-full bg-gray-100 flex items-center justify-center mb-4">
          <svg class="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
          </svg>
        </div>
        <p class="text-gray-500 text-sm">نتیجه‌ای یافت نشد</p>
      </div>

      <!-- Request Cards -->
      <div v-else class="space-y-4">
        <div 
          v-for="item in request_items_filtered"
          :key="item.Id"
          class="bg-white rounded-xl border border-gray-200 p-5 hover:shadow-md hover:border-orange-300 transition-all duration-200"
        >
          <div class="flex items-center gap-3 mb-3">
            <div class="w-12 h-12 rounded-full bg-orange-100 flex items-center justify-center flex-shrink-0">
              <svg class="w-6 h-6 text-orange-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" />
              </svg>
            </div>
            <div class="w-full">
              <h3 class="text-base font-bold text-gray-900">{{ item.ProductName }}</h3>
            </div>
          </div>
          
          <div class="grid grid-cols-3 gap-4">
            <div class="text-center p-3 bg-gray-50 rounded-lg">
              <p class="text-xs text-gray-600 mb-1">تعداد</p>
              <p class="text-sm font-bold text-gray-900">{{ item.Qty }} عدد</p>
            </div>
            <div class="text-center p-3 bg-gray-50 rounded-lg">
              <p class="text-xs text-gray-600 mb-1">شعبه</p>
              <p class="text-sm font-bold text-gray-900">{{ item.SourceBranchName }}</p>
            </div>
            <div class="text-center p-3 bg-gray-50 rounded-lg">
              <p class="text-xs text-gray-600 mb-1">کارشناس</p>
              <p class="text-sm font-bold text-gray-900">{{ item.TechName }}</p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <!-- Context Menu -->
    <vue-context ref="menu">
      <li>
        <a href="#" @click.prevent="">{{ $t('receiveSignature') }}</a>
      </li>
      <li>
        <a href="#" @click.prevent="context_menu_clicked('payments')">{{ $t('allPays') }}</a>
      </li>
    </vue-context>

  </div>
</template>
<script>
  import Vue from 'vue'
  import moment from 'moment-jalaali'

  import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
  import VueContext from 'vue-context'
  import 'vue-context/src/sass/vue-context.scss'

  Vue.component('date-picker', VuePersianDatetimePicker)
  export default {
    props:[
      'passing_data'
    ],
    data () {
      return {
        search_list: "",

        errors: [],
        start_date: '',
        end_date: '',
        request_items:[],
        request_items_filtered:[],
        clicked_request_context:null,
      }
    },
    components:{
      datePicker: VuePersianDatetimePicker,
      VueContext,
    },
    watch: {
      search_list: function() {
        var self = this;
        // console.log("search changed",this.search_list)
        self.request_items_filtered = [];
        if (self.search_list == "") {
          this.request_items_filtered = this.request_items;
        } else {
          this.request_items_filtered = [];
          this.request_items.forEach(function (val) {
            if (val.ProductName.includes(self.search_list) || val.TechName.includes(self.search_list)) {
              self.request_items_filtered.push(val)
            }
          })
        }
      },
      start_date: function () {
        this.get_report(0)
      },
      end_date: function () {
        this.get_report(0)
      },

    },
    mounted () {
      this.start_date = moment().utc().format('jYYYY/jMM/jDD')
      this.end_date = moment().utc().format('jYYYY/jMM/jDD')

      this.get_report(0)
    },
    methods: {
      open_context_menu (item) {
        var self = this
        var click_event = event
        this.clicked_request_context = item
        setTimeout(function () {
          self.$refs.menu.open(click_event, null)
        }, 150)
      },
      context_menu_clicked (func) {
        if (func == 'payments') {
          this.$router.push({ path:'/report-request/add-price-result/' + this.clicked_request_context.RecId })
        }
      },
      get_request_address (item) {
        var address = ''
        if (item.CityName != null) {
          address += item.CityName + ' '
        }
        if (item.AreaName != null) {
          address += item.AreaName + ' '
        }
        if (item.AddressText != null) {
          address += item.AddressText + ' '
        }
        return address
      },
      goToDetail (item_id) {
        this.$router.push({ name: 'groups', params: {} })
      },
      get_report (page) {
        var self = this
        var user_id = JSON.parse(localStorage.getItem('profile')).UserId

        const send_data = {
          UserId: user_id,
          FirstDate: this.start_date,
          SecondDate: this.end_date,
          Page: page,

        }
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetProductRequestReferRptByUserId', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              // console.log("response", response);
              // self.user_registered = true;
              // self.fullName = response.data.msg;
              // self.level = 2;
             if(response.data.Items.length>0){
               if (page == 0) {
                 self.request_items = response.data.Items
               } else {
                 response.data.Items.forEach(function (number) {
                   self.request_items.push(number)
                 })
               }
               self.get_report(page+1)
             }else{
               self.request_items_filtered = self.request_items;
             }

            } else {
              self.not_register = true
            }
            // this.$router.push({ path: "/post-login", params: {} });
          }).catch(e => {
          this.errors.push(e)
        })
      },

    }
  }
</script>
